import { Component, OnInit } from '@angular/core';
import { TelecomService } from 'src/app/services/telecom/telecom.service';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-holiday',
  templateUrl: './holiday.component.html',
  styleUrls: ['./holiday.component.css']
})
export class HolidayComponent implements OnInit {

  data: Array<any>;                   //all data
  filteredData: Array<any>;           //data for selected year
  yearList: Array<string>;      
  setNextYear: boolean;               //next year functionality enabled/disabled

  lambdaMessage: string = '';
  lambdaError: boolean = false;

  formValid: boolean = false;
  canEdit: boolean = true;            //true only for current and next year
  bluePrint: any = {'status': 'Enabled', 'startTime': '00:00', 'endTime': '23:59', 'startDate': this.formatDate(new Date(), 0), 'endDate': this.formatDate(new Date(), 0)};
  
  currentYear = String(new Date().getFullYear());
  nextYear = String(Number(this.currentYear)+1);

  filter: string = this.currentYear;  //yyyy

  currentUser: string = this.auth.currentUser;

  
  constructor(private telecomService: TelecomService, private auth: AuthService) { }


  ngOnInit() {
    this.setNextYear = false; 
    this.data = [];
    this.filteredData =[];
    this.yearList = [];
    this.getData();
  }


  getData(){
    this.telecomService.getRows(environment.holidaysLambdaName).then((response: any) => {
      if(response.statusCode == 200){
        this.data = response.body.holidayList.Items;
        console.log(this.data);
        for(var x = 0; x < this.data.length; x++){
          this.yearList.push(this.data[x]['Key'])     //Key = 'yyyy'
        }
        if(this.yearList.length == 0){
          this.yearList.push(this.currentYear);
          this.lambdaError = false;
          this.lambdaMessage = 'No data to display'
        }
        this.yearList.sort();
        this.applyFilter();
        if(!this.yearList.includes(this.nextYear)){
          console.log("'Create Next Year Holidays' is Active");
          this.setNextYear = true;
        }
      }else{
        this.lambdaError = true;
        this.lambdaMessage = 'failed to retrieve message data'
        console.error(response); 
      }
    });
  }


  //update the page data with output from (dataChange)
  updateLocalData(item: Array<any>){
    for(var x = 0; x < this.data.length; x++){
      if(this.filter == this.data[x]['Key']){
        this.data[x]['data'] = item;
        break;
      }
    }
  }


  //send the pages filtered data (two way bound to be in sync w/ data grid) to ddb
  updateItem(){
    var item = {action: 'put', item: {data: this.filteredData, Key: this.filter, collectionName: "holidayList", updatedBy: this.currentUser}};
    this.telecomService.saveRow(item, environment.holidaysLambdaName).then((data: any) => {
      if(data.statusCode == 200){
        this.lambdaError = false;
        this.lambdaMessage = "Data saved successfully.";
        // this.updateLocalData(data.body.message);
      }else{
        this.lambdaError = true;
        this.lambdaMessage = data.Error.message;
        console.log(data.Error);
        // this.updateLocalData(item.item);
      }
    });
  }


  applyFilter(){
    for(var x = 0; x < this.data.length; x++){
      if(this.filter == this.data[x]['Key']){
        if(this.data[x]['Key'] == this.currentYear || this.data[x]['Key'] == this.nextYear){
          this.canEdit = true;
        }else{
          this.canEdit = false;
        }
        this.filteredData = this.data[x]['data'];
        break;
      }
    }
  }


  createNextYear(){
    //disable button
    this.setNextYear = false;
    //create duplicate data
    this.yearList.splice(this.yearList.length,0,this.nextYear);
    var copy = JSON.parse(JSON.stringify(this.getHolidayListByYear(this.currentYear)));
    copy['Key'] = this.nextYear;
    for(var x = 0; x < copy['data'].length; x++){
      var item = copy['data'][x];
      item['status'] = 'Enabled';
      item['startDate'] = this.incrementYear(item['startDate']);
      item['endDate'] = this.incrementYear(item['endDate']);
    }
    this.data.push(copy);
    //apply filter
    this.filter = this.nextYear;
    this.applyFilter();
    //save new year
    this.updateItem();
  }

  incrementYear(date: string){
    var dateObj = new Date(date);
    var nextYear = dateObj.getFullYear() + 1;
    dateObj.setFullYear(nextYear);
    return this.formatDate(dateObj, 1);
  }

  //wire year format. yyyy-mm-dd
  formatDate(date: Date, addTime: number){
    date.setDate(date.getDate() + addTime)
    var year: any = date.getFullYear();
    var month: any = date.getMonth()+1;
    var dt: any = date.getDate();
    if (dt < 10) {
      dt = '0' + dt;
    }
    if (month < 10) {
      month = '0' + month;
    }
    return year + '-' + month + '-' + dt;
  }


  getHolidayListByYear(year: any){
    for(var x = 0; x < this.data.length; x++){
      if(year == this.data[x]['Key']){
        return this.data[x];
      }
    }
  }


  validate(item: any){
    //table row data does not have a unique key. stored as JSON with year as key
    this.lambdaMessage = '';

    //holiday title
    if(!item.holiday || item.holiday.length < 3){
      this.lambdaMessage = 'holiday title is too short';
      this.lambdaError = true;
      return false;
    }

    if(item.startDate == ''){
      this.lambdaMessage = 'Invalid start date';
      this.lambdaError = true;
      return;
    }

    if(item.endDate == ''){
      this.lambdaMessage = 'Invalid end date';
      this.lambdaError = true;
      return;
    }

    //build start and end objects
    var start = new Date(item.startDate);
    start.setHours(this.getHoursFromString(item.startTime), this.getMinutesFromString(item.startTime));
    var end = new Date(item.endDate);
    end.setHours(this.getHoursFromString(item.endTime), this.getMinutesFromString(item.endTime));

    //start before end
    if(start > end){
      this.lambdaMessage = 'holiday end date/time must be after holiday start date/time';
      this.lambdaError = true;
      return false;
    }

    //correct year
    const min = new Date(Number(this.filter), 0, 0, 0, 0, 0);
    const max = new Date(Number(this.filter), 11, 31, 23, 59, 59);
    console.log(min);
    console.log(max);

    if((min > start) || (start > max)){
      this.lambdaMessage = 'starting time must be in the year ' + this.filter;
      this.lambdaError = true;
      return false;
    }

    if(((min > end) || (end > max))){
      this.lambdaMessage = 'end time must be in the year ' + this.filter;
      this.lambdaError = true;
      return false;
    }

    return true;
  }


  getHoursFromString(milTime: string){
    if(!milTime){
      return 0;
    }
    var hrs = milTime.split(':')[0];
    if(hrs.startsWith('0')){
      hrs = hrs.substring(1,hrs.length);
    }
    return Number(hrs);
  }


  getMinutesFromString(milTime: string){
    if(!milTime){
      return 0;
    }
    var min = milTime.split(':')[1];
    if(min.startsWith('0')){
      min = min.substring(1, min.length);
    }
    return Number(min);
  }

  displayUS(date: string){
    const dateArray = date.split('-');
    return dateArray[1] + '/' + dateArray[2] + '/' + dateArray[0];
  }

}
